import React, { useState } from "react";
import "../../index.css";
import "../../App.css";
import { Row, Radio, Typography } from "antd";
import { painEntryFormConstants } from "../../helpers/painEntryFormConstants";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "./../../redux-toolkit/store/store";
import { handleUpdateEnergyLevel } from "../../redux-toolkit/slices/painEntryFormSlice";

const TeEnergyLevel = () => {
  const energyLevel = useSelector(
    (state: RootState) => state.painEntryForm.energyLevel
  );
  const dispatch = useDispatch();
  const handleSelect = (value: string) => {
    dispatch(handleUpdateEnergyLevel(value));
  };

  return (
    <div className="flex flex-col gap-2">
      <label className="h6 text-theme-text-secondary">
        <strong>Energy Level *</strong>
      </label>
      <p className="body1 text-theme-text-primary mb-4">
        Select the option that best describes your current energy level.
      </p>
      <Radio.Group
        onChange={(e) => handleSelect(e.target.value)}
        value={energyLevel}
      >
        {painEntryFormConstants.energyLevels.map(({ value, label }) => {
          return (
            <Radio key={value} value={value}>
              {label}
            </Radio>
          );
        })}
      </Radio.Group>
    </div>
  );
};

export default TeEnergyLevel;
